<template>
  <div v-if="security" class="car-info">
    <h3>Проверка авто</h3>

    <div class="security-data" v-if="security.avtocod_is_end">
      <div class="security-base-information">
        <h4>Полис</h4>
        <p>Номер полиса: {{security.avtocod_policy_number}}</p>
        <p>
          Тип владельца: {{ security.avtocod_owner_type }}
        </p>
        <p>Владелец: {{ security.avtocod_policy_owner }}</p>
        <p>Статус: {{security.avtocod_policy_status}}</p>
        <p>Страховая: {{security.avtocod_policy_comment}}</p>
        <h4>Розыск</h4>
        <p>
          <span v-if="security.avtocod_wanted_is_wanted"> В розыске</span>
          <span v-else>Нет</span>
        </p>
        <h4>Автомобиль</h4>
        <p>Марка: {{security.avtocod_identifiers_brand_name}}</p>
        
        <p>Год выпуска: {{security.avtocod_identifiers_release_year}}</p>
        
        <p>{{security.avtocod_platger_count}}</p>

        <h4>Владение</h4>
        <p>Начало владения: {{security.avtocod_owner_start_dt}}</p>
        <p>Дней владения: {{security.avtocod_owner_days_passed}}</p>
        
      </div>
    </div>
    <div v-else><p>Еще не проверен</p></div>
    
  </div>
</template>

<script>
export default {
  name: 'DriverSecurityInfo',
  props: ['security','car'],
};
</script>

<style scoped>

.security-data{
  display: flex;
  justify-content: space-evenly;
}

.security-base-information h3 {
  text-align: center;
}

.company-info h3 {
  font-size: 20px;
  font-weight: bold;
}

.company-info p {
  margin: 5px 0;
}

.company-info p:first-child {
  margin-top: 0;
}

.status-company{
  display: flex;
  justify-content: center;
  margin: 10px 0;
}

.status-content{
  margin-left: 10px;
  margin-bottom: 4px;
}

.security-base-information {
  display: flex;
  flex-direction: column;
  text-align: left;
  flex:1;
}

.security-base-information p{
  margin-top: 3px;
}

.owner-comment{
  font-size: 12px;
}

.denied{
  border-radius: 2px;
  padding: 1px;
  background-color: rgba(182,0,24,0.4);
}

.success{
  border-radius: 2px;
  padding: 1px;
  background-color: rgba(152,236,131,0.6);
}

.information{
  border-radius: 2px;
  padding: 1px;
  background-color: rgba(202,181,152,0.6);
}

.small-size{
  font-size: 12px;
}
h4{
  margin-top: 15px;
}

.car-info{
  border-radius: 10px;
  margin-top: 5px;
  border: 1px solid #ccc;
  padding: 15px;
}
</style>
